import type { InferOutput } from 'valibot'
import { email, fallback, nullish, object, optional, parser, pipe, picklist, regex, string } from 'valibot'

export const loginBodySchema = object({
  email: pipe(string(), email()),
  password: nullish(string()),
})

export const redirectToQuerySchema = object({
  redirectTo: fallback(
    optional(
      pipe(
        string(),
        regex(/^\/(?!\/)/, 'redirectTo must start with "/"'),
      ),
    ),
    undefined,
  ),
})

export const redirectToQueryParser = parser(redirectToQuerySchema)

export type RedirectToQuery = InferOutput<typeof redirectToQuerySchema>

export const issuerSchema = picklist(['am', 'auth0'])

export type Issuer = InferOutput<typeof issuerSchema>